export const winstonpos = {
  seo: {
    title: 'WinstonPOS integration | Bistroo',
    description: 'Connect WinstonPOS to your Bistroo webshop. Online orders automatically arrive as POS tickets — quick to set up, works flawlessly.',
  },
  hero: {
    category: 'POS system',
    description: 'Online orders via Bistroo arrive directly as POS tickets in WinstonPOS — fully automatically, without any intermediate steps.',
  },
  about: {
    title: 'What does WinstonPOS do?',
    p1: 'WinstonPOS is a modern, cloud-based POS system developed specifically for the Dutch restaurant industry. It offers an intuitive touchscreen interface, inventory management and extensive reporting — all in one platform that grows with your business.',
    p2: 'Thanks to the direct connection with Bistroo, WinstonPOS processes online orders just as quickly as table transactions at the counter. Product options, allergens, pickup times — everything is passed on to the POS screen and kitchen printer.',
    benefits_title: 'What does the connection deliver?',
    benefits: [
      'Automatic POS ticket for every online order',
      'Product options and special requests passed on',
      'Pickup time visible on kitchen printer',
      'Combined revenue report online and offline',
      'Support for multiple locations',
    ],
  },
  wordcloud_title: 'WinstonPOS at a glance',
  wordcloud: ['Touchscreen POS', 'Cloud POS', 'POS screen', 'Kitchen printer', 'Table management', 'Daily report', 'Multiple printers', 'Receipt print', 'Split bill', 'Staff login', 'Location management', 'API integration', 'Order processing', 'Hospitality software', 'Revenue insight'],
  usp: {
    heading: 'Why connect Bistroo to WinstonPOS?',
    items: [
      { icon: 'bi-receipt', title: 'Instant POS ticket', text: 'Every online order automatically appears on the WinstonPOS screen. Your team doesn\'t need to retype anything.' },
      { icon: 'bi-printer-fill', title: 'Smart printer routing', text: 'Hot dishes to the kitchen, drinks to the bar. WinstonPOS routes each item to the correct printer.' },
      { icon: 'bi-graph-up', title: 'Combined revenue', text: 'Online orders and POS transactions come together in one WinstonPOS report. Complete overview without manual combining.' },
      { icon: 'bi-emoji-smile-fill', title: 'Less stress during busy moments', text: 'During the lunch rush the connection automatically processes all channels. Your team focuses on preparing and serving.' },
      { icon: 'bi-list-check', title: 'Allergens & options correct', text: 'Product options, variants and allergen instructions are transferred flawlessly to the WinstonPOS till screen. No misunderstandings, no complaints.' },
      { icon: 'bi-building', title: 'Scalable to multiple locations', text: 'WinstonPOS and Bistroo support multiple locations. Manage all branches from one Bistroo Merchant Portal and switch easily between locations.' },
    ],
  },
  setup: {
    heading: 'How to connect WinstonPOS to Bistroo',
    steps: [
      'Activate the Bistroo module in your WinstonPOS management panel.',
      'Copy your WinstonPOS location code and API key from the settings.',
      'Go to Bistroo Merchant Portal → Integrations → WinstonPOS.',
      'Enter the location code and API key and confirm the connection.',
      'Place a test order and check that the POS ticket arrives correctly.',
    ],
  },
  faq: {
    items: [
      { q: 'Which WinstonPOS version does the connection support?', a: 'The Bistroo connection is compatible with WinstonPOS version 3.0 and higher. Contact WinstonPOS support if you are unsure which version you are using.' },
      { q: 'Can multiple locations be connected?', a: 'Yes. You can link each Bistroo location to the corresponding WinstonPOS point of sale. Manage everything centrally in your Bistroo dashboard.' },
      { q: 'Are special requests and product options passed on?', a: 'Absolutely. All notes, variants and allergen information that customers include are displayed as instructions on the POS ticket.' },
      { q: 'How do I set up product time slots or time blocks?', a: 'Pickup and delivery time slots are configured in the Bistroo Merchant Portal. The scheduled time then appears on the POS ticket in WinstonPOS.' },
      { q: 'What does the WinstonPOS integration cost?', a: 'The connection is included in your Bistroo subscription. Check with WinstonPOS whether your subscription supports API access.' },
    ],
  },
}
